import './schedule.css';
import React, {useEffect, useState} from 'react';
import {Link} from "react-router-dom";

const SchedulePage = () => {
    const [token, setToken] = useState('');
    const [result, setResult] = useState([]);
    const [ResultHakgi, setResultHakgi] = useState({});
    const [rowSpanInfo, setRowSpanInfo] = useState({});

    const pastelColors = [
        '#f8d7da', '#d1ecf1', '#d4edda', '#fff3cd',
        '#d6d8d9', '#e2e3e5', '#cfe2ff', '#e2f0d9',
        '#ffe5b4', '#e0bbE4', '#ffcccb', '#c8e6c9'
    ];

    const getColorFromName = (name) => {
        if (!name) return '#ffffff';
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % pastelColors.length;
        return pastelColors[index];
    };

    const extractSubjectName = (html) => {
        if (!html) return '';
        const match = html.match(/^([^<]+)/);
        return match ? match[1] : '';
    };

    const calculateRowspan = (data, dayKey) => {
        console.log(`🔍 calculateRowspan for ${dayKey}:`, data.map(row => row[dayKey]));
        
        const result = new Array(data.length).fill(null).map(() => ({show: true, rowspan: 1}));
        let prevValue = '';
        let startIndex = 0;

        for (let i = 0; i <= data.length; i++) {
            const current = i < data.length ? data[i][dayKey]?.trim() : null;

            if (i === data.length || current !== prevValue) {
                const span = i - startIndex;
                if (prevValue && span > 1) {
                    console.log(`🔍 ${dayKey}: Setting rowspan ${span} for rows ${startIndex}-${i-1}, subject: ${prevValue}`);
                    result[startIndex].rowspan = span;
                    for (let j = startIndex + 1; j < i; j++) {
                        result[j].show = false;
                        console.log(`🔍 ${dayKey}: Hiding row ${j}`);
                    }
                }
                startIndex = i;
                prevValue = current;
            }
        }

        console.log(`🔍 ${dayKey} final result:`, result);
        return result;
    };

    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) setToken(storedToken);

        fetch(`/backend/hakgi_info?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(setResultHakgi)
            .catch(console.error);
    }, []);

    useEffect(() => {
        const secretKey = localStorage.getItem('secretKey');
        const storedToken = localStorage.getItem('token');
        if (storedToken) setToken(storedToken);

        fetch(`/backend/schedule?token=${encodeURIComponent(storedToken)}&secretKey=${encodeURIComponent(secretKey)}`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({})
        })
            .then(res => res.json())
            .then(data => {
                console.log('🔍 시간표 원본 데이터:', data);
                setResult(data);
                const rowSpanData = {
                    MON: calculateRowspan(data, 'MON'),
                    TUE: calculateRowspan(data, 'TUE'),
                    WED: calculateRowspan(data, 'WED'),
                    THU: calculateRowspan(data, 'THU'),
                    FRI: calculateRowspan(data, 'FRI')
                };
                console.log('🔍 RowSpan 계산 결과:', rowSpanData);
                setRowSpanInfo(rowSpanData);
            })
            .catch(console.error);
    }, []);

    return (
        <div className="App App-header gnb_b" id="schedule">
            <header>
                <div className="gnb_1">
                    <Link className="gnb_logo" to="/"></Link>
                </div>
            </header>
            <div className="body">
                <div className="main_box_gnbs">
                    <span>수업시간표</span>
                    <span>[{ResultHakgi.HAKBUN}] {ResultHakgi.YEAR}년 {ResultHakgi.HAKGI}학기</span>
                </div>
                <div className="menubox">
                    <table>
                        <thead>
                        <tr>
                            <th>교시</th>
                            <th>월</th>
                            <th>화</th>
                            <th>수</th>
                            <th>목</th>
                            <th>금</th>
                        </tr>
                        </thead>
                        <tbody>
                        {result.map((row, rowIndex) => {
                            console.log(`🔍 Row ${rowIndex} (${row.GYOSI}):`, {
                                MON: row.MON,
                                TUE: row.TUE, 
                                WED: row.WED,
                                THU: row.THU,
                                FRI: row.FRI
                            });
                            
                            return (
                                <tr key={rowIndex}>
                                    <td dangerouslySetInnerHTML={{__html: row.GYOSI}}/>
                                    {['MON', 'TUE', 'WED', 'THU', 'FRI'].map((day, dayIndex) => {
                                        const info = rowSpanInfo[day]?.[rowIndex];
                                        const html = row[day];
                                        
                                        console.log(`🔍 Row ${rowIndex}, Day ${day} (${dayIndex}):`, {
                                            html: html,
                                            info: info,
                                            show: info?.show,
                                            rowspan: info?.rowspan
                                        });
                                        
                                        // rowspan으로 인해 숨겨져야 하는 셀은 렌더링하지 않음
                                        if (!info || !info.show) {
                                            console.log(`🔍 Skipping ${day} at row ${rowIndex} (hidden by rowspan)`);
                                            return null;
                                        }
                                        
                                        // 빈 셀은 빈 td로 렌더링
                                        if (!html || html.trim() === '') {
                                            console.log(`🔍 Empty cell for ${day} at row ${rowIndex}`);
                                            return <td key={day} rowSpan={info.rowspan} style={{backgroundColor: 'transparent'}}></td>;
                                        }

                                        const subjectName = extractSubjectName(html);
                                        const bgColor = getColorFromName(subjectName);
                                        console.log(`🔍 Rendering ${day} at row ${rowIndex}:`, subjectName);

                                        return (
                                            <td key={day} rowSpan={info.rowspan} style={{backgroundColor: 'transparent'}}>
                                                <div className="class-box" style={{backgroundColor: bgColor}}>
                                                    <div dangerouslySetInnerHTML={{__html: html}}/>
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default SchedulePage;
